import { HttpContextToken } from '@angular/common/http';

/**
 * Set on a request that is not a user-visible configuration change (for example a LeapBot chat
 * message): `notificationsInterceptor` and `requestLogInterceptor` let it through untouched, so
 * it never shows up in the notifications drawer or in the audit log of config changes.
 */
export const SKIP_ACTIVITY_LOG = new HttpContextToken<boolean>(() => false);
